import React from "react";

function Main({ children }) {
  return <main id="main">{children}</main>;
}

export default Main;
